import * as React from 'react';
import * as Yup from 'yup';
import { Mutation } from 'react-apollo';
import { withRouter } from 'react-router-dom';
import { RouteComponentProps } from 'react-router';
import { Field, Formik, FieldProps, FormikProps, ErrorMessage } from 'formik';

import Span from '../../typography/Span';
import Label from '../../typography/Label';
import Box from '../../components/primitives/Box';
import { ValidateAdminUser } from '../../graphql';
import { StyledForm, Button, StyledInput } from '../../components';
import { formatGqlError } from '../../utils/helpers';

interface FormValues {
  password: string;
  confirmPassword: string;
}

const ResetPasswordValidationSchema = Yup.object().shape({
  password: Yup.string()
    .min(6, 'Please enter a password at least 6 digits long.')
    .required('Required'),
  confirmPassword: Yup.string()
    .min(6, 'Please enter a password at least 6 digits long.')
    .required('Required'),
});

type ResetPasswordProps = RouteComponentProps & {
  id: string | null;
  onComplete: (data: any) => void;
  otp: string;
};

type ResetPasswordState = {
  showPassword: boolean;
  error: string;
};

class ResetPasswordForm extends React.Component<ResetPasswordProps, ResetPasswordState> {
  state: ResetPasswordState = {
    showPassword: false,
    error: '',
  };
  render() {
    const { onComplete, id, otp } = this.props;
    const { showPassword } = this.state;
    return (
      <Mutation mutation={ValidateAdminUser} onCompleted={onComplete}>
        {(validateUser, { loading, error }) => (
          <Formik
            validationSchema={ResetPasswordValidationSchema}
            initialValues={{
              password: '',
              confirmPassword: '',
            }}
            validateOnChange={true}
            onSubmit={(values: FormValues) => {
              if (values.password !== values.confirmPassword) {
                this.setState({ error: 'Passwords do not match' });
              } else {
                this.setState({ error: '' });
                validateUser({
                  variables: { otp, id, ...values },
                });
                return;
              }
            }}
            render={(formikProps: FormikProps<FormValues>) => {
              return (
                <StyledForm>
                  <Field
                    name="password"
                    render={({ field }: FieldProps<FormValues>) => (
                      <Box width="100%" mb={3}>
                        <Label>Password</Label>
                        <StyledInput
                          px={2}
                          {...field}
                          showEyeIcon={true}
                          placeholder="Choose a password"
                          passwordVisible={showPassword}
                          type={showPassword ? 'text' : 'password'}
                          onTogglePassword={() =>
                            this.setState({
                              showPassword: !this.state.showPassword,
                            })
                          }
                        />
                        <ErrorMessage name="password">
                          {msg => (
                            <Span mt={2} color="error" textAlign="right">
                              {msg}
                            </Span>
                          )}
                        </ErrorMessage>
                      </Box>
                    )}
                  />
                  <Field
                    name="confirmPassword"
                    render={({ field }: FieldProps<FormValues>) => (
                      <Box width="100%" mb={3}>
                        <Label>Confirm Password</Label>
                        <StyledInput
                          px={2}
                          {...field}
                          showEyeIcon={true}
                          placeholder="Confirm password"
                          passwordVisible={showPassword}
                          type={showPassword ? 'text' : 'password'}
                          onTogglePassword={() =>
                            this.setState({
                              showPassword: !this.state.showPassword,
                            })
                          }
                        />
                        <Span mt={2} color="error" textAlign="right">
                          {this.state.error}
                        </Span>
                      </Box>
                    )}
                  />
                  <Button isLoading={loading} type="submit" mt={2} mb={3} text="SUBMIT" />
                  {error && (
                    <Span width="100%" textAlign="center" color="error" mb={3}>
                      {formatGqlError(error)}
                    </Span>
                  )}
                </StyledForm>
              );
            }}
          />
        )}
      </Mutation>
    );
  }
}

export default withRouter(ResetPasswordForm);



// WEBPACK FOOTER //
// ./src/forms/admin/ResetPasswordForm.tsx